/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventFollowState
 */
export interface EventFollowState {
    /**
     * Whether the authenticated / requested user is currently subscribed to this event.
     * @type {boolean}
     * @memberof EventFollowState
     */
    isFollowed: boolean;
    /**
     * Total number of users following this event.
     * @type {number}
     * @memberof EventFollowState
     */
    followerCount: number;
}

/**
 * Check if a given object implements the EventFollowState interface.
 */
export function instanceOfEventFollowState(value: object): value is EventFollowState {
    let isInstance = true;
    isInstance = isInstance && "isFollowed" in value && value["isFollowed"] !== undefined;
    isInstance = isInstance && "followerCount" in value && value["followerCount"] !== undefined;

    return isInstance;
}

export function EventFollowStateFromJSON(json: any): EventFollowState {
    return EventFollowStateFromJSONTyped(json, false);
}

export function EventFollowStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventFollowState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isFollowed': json['is_followed'],
        'followerCount': json['follower_count'],
    };
}

export function EventFollowStateToJSON(value?: EventFollowState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_followed': value.isFollowed,
        'follower_count': value.followerCount,
    };
}

